<template>
  <div
   v-closable="{ exclude: ['ContextItemEditableValue'], isClosable: true, handler: 'handleCancelEditing'}"
  >
    <div :ref="'ContextItemEditableValue'"
      class="context--item--editable--value--wrapper"
      :class="{'hovered': isEditing}"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <div @[eventName]="handleGlobalEditing" class="context--item--editable--value--container" :class="[{'editing': isEditing}]">
        <div v-if="icon !== null" class="icon">
          <v-tooltip left :disabled="iconTooltip === null">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">{{ icon }}</v-icon>
            </template>
            <span>{{ iconTooltip }}</span>
          </v-tooltip>
        </div>
        <span class="attribute">{{ attribute }}</span>
        <template v-for="(inputObject, index) in valuesText">
          <input
          v-show="isEditing" :class="[inputObject.type === 'text' ? isMaxContentFlex ? 'flex-max-content' : 'value--text' :'value']"
          :key="'editableValueInput' + index"
          :disabled="!isEditing"
          :type="inputObject.type"
          :placeholder="inputObject.placeholder"
          :value="inputObject.value"
          :ref="'wrld_editable_input_' + index"
          @input="handleInput($event, index)"
          v-on="listeners"
          />
          <span class="splitter" :key="'editableValueSplitter' + index" v-if="(index !== valuesText.length - 1) && inputObject.splitter != null && isEditing" >{{ inputObject.splitter }}</span>
        </template>
        <span v-show="!isEditing" class="value" >{{ valuesObject.text }}</span>
        <span v-show="isEditing" class="value measurement">{{valuesObject.measurement}}</span>
      </div>
      <div v-show="hover || isEditing" class="actions--panel">
          <div class="icon-action" v-for="(action, index) in actions" :key="'action-' + index">
            <v-tooltip top :disabled="action.tooltip === undefined || action.tooltip === ''">
              <template v-slot:activator="{ on }">
                <v-icon v-if="action !== null" v-on="on" @click="action.callback">{{action.icon}}</v-icon> <!-- dependence on Vuetify   -->
              </template>
              <span>{{ action.tooltip }}</span>
            </v-tooltip>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContextItemEditableValue',
  props: {
    icon: { type: String, default: null },
    iconTooltip: { type: String, default: null },
    attribute: { type: String, default: null },
    valuesObject: { type: Object, default: () => {} },
    eventName: { type: String, default: '' },
    extraActions: { type: Array, default: () => null },
    savedByEnter: { type: Boolean, default: false },
    isMaxContentFlex: { type: Boolean, default: false }
  },
  data () {
    return {
      isEditing: false,
      hover: false,
      valuesText: []
    }
  },
  mounted () {
    this.initializeEditing()
  },
  methods: {
    initializeEditing () {
      this.valuesText = []
      Object.keys(this.valuesObject).forEach((key) => {
        if (key !== 'measurement' && key !== 'text' && key !== 'splitter' && key !== 'translate') {
          this.valuesText.push({
            key: key,
            value: this.valuesObject[key],
            type: typeof this.valuesObject[key] === 'string' ? 'text' : typeof this.valuesObject[key]
          })
        }
      })
    },
    handleEditing () {
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.$nextTick(() => {
          this.$refs['wrld_editable_input_0'][0].focus()
        })
      }
    },
    handleCancelEditing (evt) {
      this.initializeEditing()
      this.isEditing = false
      // this.initializeEditing()
      // this.$emit('cancel-emitted')
    },
    handleSaveEditing () {
      this.$emit('save-emitted', this.valuesText)
      this.isEditing = false
    },
    handleGlobalEditing () {
      if (!this.isEditing) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs['wrld_editable_input_0'][0].focus()
          })
        }, 100)
      }
      this.isEditing = true
    },
    handleInput (evt, index) {
      if (evt.target.type === 'text') {
        this.valuesText[index].value = evt.target.value
        this.$emit('input-emitted', this.valuesText)
      } else {
        this.valuesText[index].value = Number(evt.target.value)
        this.$emit('input-emitted', this.valuesText)
      }
    }
  },
  computed: {
    listeners () {
      if (this.savedByEnter) {
        return { keyup: (event) => {
          if (event.key === 'Enter') {
            this.handleSaveEditing()
          }
        } }
      } else {
        return {}
      }
    },
    actions () {
      if (this.isEditing) {
        if (this.extraActions !== null) {
          return [].concat([
            {
              icon: 'fas fa-times',
              tooltip: 'Cancel',
              callback: this.handleCancelEditing
            },
            {
              icon: 'fas fa-save',
              tooltip: 'Save',
              callback: this.handleSaveEditing
            }
          ], this.extraActions.map((action) => {
            return { ...action, callback: action.callback.bind(null, this.handleCancelEditing) }
          }))
        } else {
          return [
            {
              icon: 'fas fa-times',
              tooltip: 'Cancel',
              callback: this.handleCancelEditing
            },
            {
              icon: 'fas fa-save',
              tooltip: 'Save',
              callback: this.handleSaveEditing
            }
          ]
        }
      } else {
        return [
          {
            icon: 'edit',
            tooltip: 'Edit',
            callback: this.handleEditing
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context--item--editable--value--wrapper {
  position: relative;
  border-radius: 5px;
  width: 39vw;
  &.hovered {
     background-color: #f2f2f2;
  }
  &:hover {
    background-color: #f2f2f2;
  }
  .context--item--editable--value--container {
    position: relative;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: nowrap;
    align-items: left;
    justify-content: flex-start;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-bottom: 1px;
    &.editing {
      border-color: #767676;
    }
    .icon {
      i {
        color: #767676;
        font-size: 16px;
      }
      flex: 1 1 10%;
      margin-right: 15px;
      max-width: 16px;
    }
    .attribute {
      color: #767676;
      font-size: 13px;
      font-weight: bold;
      flex: 1 1 max-content;
      margin-right: 5px;
      padding-top: 2px;
    }
    input {
      &:focus {
        border-bottom: 1px solid #484848 !important;
      }
      &.value {
        flex: 1 1 auto;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: none;
        background-color: #ededed;
        color: inherit;
        font-family: inherit;
        color: #484848;
        font-size: 13px;
        font-weight: bold;
        width: 40px;
        background-color: white;
      }

      &.value--text {
        flex: 1 1 auto;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: none;
        background-color: #ededed;
        color: inherit;
        font-family: inherit;
        color: #484848;
        font-size: 13px;
        font-weight: bold;
        &.focus {
          border-bottom: 1px solid #484848;
        }
      }
      &.flex-max-content {
        flex: 1 1 max-content;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: none;
        background-color: transparent;
        color: inherit;
        font-family: inherit;
        color: #484848;
        font-size: 13px;
        font-weight: bold;
        &.focus {
          border-bottom: 1px solid #484848;
        }
      }
    }
    span {
      &.measurement {
        margin-left: 2px;
      }
      &.value {
        flex: 1 1 auto;
        display: block;
        color: #484848;
        font-size: 13px;
        font-weight: bold;
        margin-right: 60px;
        padding-top: 2px;
      }
      &.splitter {
        flex: 1 1 auto;
        display: block;
        color: #484848;
        font-size: 13px;
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }
  .actions--panel {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 9;
    background-color: #f2f2f2;
    height: calc(100% - 5px);
    display: flex;
    border-left: 1px solid #ededed;

    .icon-action {
      position: relative;
      top: 0;
      width: 20px;
      height: 20px;
      text-align: center;
      border-radius: 5px;
      i {
        color: #767676;
        font-size: 18px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
}
</style>
